module.exports = __webpack_public_path__ + "static/screen00-7f1203842015b4c990a3f806c964522b.jpg";